/* eslint-disable
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import EntryActions from 'actions/EntryActions';
import BenchlingConfig from 'BenchlingConfig';
import ExportActions from 'exports/ExportActions';
import {FolderDefaultsKey} from 'FolderDefaults';
import EntityStore from 'stores/EntityStore';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';

class EntryInformationPanelView extends BasicInformationPanelView {
  static initClass() {
    // Used by BasicInformationPanelView
    this.prototype.showPatentsafeExport =
      BenchlingConfig.ENABLE_PATENTSAFE && EntityStore.currentUser() != null;
  }

  initialize() {
    this.saveModel = this.saveModel.bind(this);
    this.deleteModel = this.deleteModel.bind(this);
    this.requestExport = this.requestExport.bind(this);
    super.initialize(...arguments);
  }

  folderDefaultsKey() {
    return FolderDefaultsKey.NOTEBOOK;
  }
  saveModel(data) {
    EntryActions.saveFileData(this.model.id, {data, success: this.onSaveSuccess});
  }

  deleteModel() {
    EntryActions.delete(this.model.id, {success: this.onDeleteSuccess});
  }

  requestExport() {
    ExportActions.requestExportFile(this.model.id);
  }
}
EntryInformationPanelView.initClass();

export default EntryInformationPanelView;
